import { AuthenticationActionTypes, AuthenticationState, LOGIN_TOKEN, PARCEIRO_DATA, SSE_VALUE, SSE_VALUEEnd } from "domain/types/authentication/authentication"
import { ParceiroResponse } from "domain/types/parceiro/parceiroResponse"

const INITIAL_STATE: AuthenticationState = {
	isAuthenticated: false, //acho que isso é desnecessário
	authState: false,
	parceiroState: {} as ParceiroResponse,
	sseValue: undefined,
	sseValueEnd: undefined
}

export function AuthenticationReducer(state = INITIAL_STATE, action: AuthenticationActionTypes): AuthenticationState {
	switch (action.type) {
		case LOGIN_TOKEN:
			return { ...state, authState: action.payload }
		case PARCEIRO_DATA:
			return { ...state, parceiroState: action.payload }

		case SSE_VALUE:  //TODO REMOVER
			return { ...state, sseValue: action.payload }
		case SSE_VALUEEnd:   //TODO REMOVER
			return { ...state, sseValueEnd: action.payload }
		default:
			return state
	}
}